import { Flex } from "@chakra-ui/react";
import React from "react";
import Statistics from "./components/Statistics";

function Data() {

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Statistics
      />
    </Flex>
  );
}

export default Data;
